/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'windows': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M486.4 134.4L960 64v422.4H486.4v-352z" _fill="#90C300"/><path pid="1" d="M64 198.4l358.4-51.2v345.6H64V198.4z" _fill="#F8672C"/><path pid="2" d="M486.4 889.6L960 960V550.4H486.4v339.2z" _fill="#FFC400"/><path pid="3" d="M64 825.6l358.4 51.2V550.4H64v275.2z" _fill="#00B4F2"/>'
  }
})
